import { useSuspenseUserAccess } from "@/api/user.api";
import { useTenantStore } from "@/store/tenant/tenant.store";
import React, { PropsWithChildren, useMemo } from "react";

interface RenderWithPermissionsProps extends PropsWithChildren {
    module: string;
    permissionLevel:
        | ("create" | "read" | "update" | "delete")[]
        | "create"
        | "read"
        | "update"
        | "delete";
}

export const RenderWithPermissions: React.FC<RenderWithPermissionsProps> = ({
    children,
    module,
    permissionLevel,
}) => {
    const selectedTenant = useTenantStore((state) => state.selectedTenant);
    const { data: userAccess } = useSuspenseUserAccess(selectedTenant?.id);

    const relevantPermission = useMemo(
        () => userAccess?.find((p) => p.module === module),
        [userAccess, module],
    );

    const hasRequiredPermission = useMemo(() => {
        if (Array.isArray(permissionLevel)) {
            return permissionLevel.some((level) => relevantPermission?.[level] ?? false);
        }

        return relevantPermission?.[permissionLevel] ?? false;
    }, [relevantPermission, permissionLevel]);

    if (!userAccess || userAccess.length === 0 || !hasRequiredPermission) {
        return null;
    }

    return <>{children}</>;
};
